import { Link } from 'react-router-dom';

const Header = () => {
	return <Link to='/'>NC news</Link>;
};
export default Header;
